<div class="space-y-6">
	<!-- Messages -->
	@if (errorMessage()) {
		<div
			class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center gap-2"
		>
			<svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
				<path
					fill-rule="evenodd"
					d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
					clip-rule="evenodd"
				/>
			</svg>
			<span>{{ errorMessage() }}</span>
		</div>
	}
	@if (successMessage()) {
		<div
			class="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg flex items-center gap-2"
		>
			<svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
				<path
					fill-rule="evenodd"
					d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
					clip-rule="evenodd"
				/>
			</svg>
			<span>{{ successMessage() }}</span>
		</div>
	}

	<!-- Split View: Form + Preview -->
	<div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
		<!-- Left Side: Form Fields -->
		<div class="space-y-6">
			<div class="bg-white rounded-2xl shadow-lg p-8">
				<h2 class="text-xl font-cenzo font-bold text-primary mb-6 flex items-center gap-2">
					<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
						/>
					</svg>
					Service Details
				</h2>

				<form [formGroup]="serviceForm" class="space-y-6">
					<!-- Category Selection -->
					<div class="form-group">
						<label class="form-label"> Category <span class="required">*</span> </label>
						<div class="input-with-icon">
							<svg
								class="input-icon w-5 h-5"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
								/>
							</svg>
							<select
								formControlName="category_id"
								class="form-input form-select"
								[class.has-error]="isFieldInvalid('category_id')"
							>
								<option value="">Select a category</option>
								@for (category of categories(); track category.id) {
									<option [value]="category.id">{{ category.name }}</option>
								}
							</select>
						</div>
						@if (isFieldInvalid('category_id')) {
							<p class="form-error">
								<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
									<path
										fill-rule="evenodd"
										d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
										clip-rule="evenodd"
									/>
								</svg>
								Category is required
							</p>
						}
					</div>

					<!-- Service Name -->
					<div class="form-group">
						<label class="form-label">
							Service Name <span class="required">*</span>
						</label>
						<div class="input-with-icon">
							<svg
								class="input-icon w-5 h-5"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M13 10V3L4 14h7v7l9-11h-7z"
								/>
							</svg>
							<input
								type="text"
								formControlName="service_name"
								placeholder="e.g., Premium Hair Styling"
								class="form-input"
								[class.has-error]="isFieldInvalid('service_name')"
							/>
						</div>
						@if (isFieldInvalid('service_name')) {
							<p class="form-error">
								<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
									<path
										fill-rule="evenodd"
										d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
										clip-rule="evenodd"
									/>
								</svg>
								Service name is required
							</p>
						}
					</div>

					<!-- Tagline -->
					<div class="form-group">
						<label class="form-label"> Tagline <span class="required">*</span> </label>
						<div class="input-with-icon">
							<svg
								class="input-icon w-5 h-5"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
								/>
							</svg>
							<input
								type="text"
								formControlName="tagline"
								placeholder="e.g., Experience luxury hair care"
								class="form-input"
								[class.has-error]="isFieldInvalid('tagline')"
							/>
						</div>
						<p class="form-hint">A catchy phrase that appears on the service card</p>
						@if (isFieldInvalid('tagline')) {
							<p class="form-error">
								<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
									<path
										fill-rule="evenodd"
										d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
										clip-rule="evenodd"
									/>
								</svg>
								Tagline is required
							</p>
						}
					</div>

					<!-- Short Description -->
					<div class="form-group">
						<label class="form-label">
							Short Description <span class="required">*</span>
						</label>
						<div class="input-with-icon">
							<svg
								class="input-icon w-5 h-5"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M4 6h16M4 12h16M4 18h7"
								/>
							</svg>
							<input
								type="text"
								formControlName="short_description"
								placeholder="Brief one-line description for listings"
								class="form-input"
								[class.has-error]="isFieldInvalid('short_description')"
							/>
						</div>
						@if (isFieldInvalid('short_description')) {
							<p class="form-error">
								<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
									<path
										fill-rule="evenodd"
										d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
										clip-rule="evenodd"
									/>
								</svg>
								Short description is required
							</p>
						}
					</div>

					<!-- Full Description -->
					<div class="form-group">
						<label class="form-label">
							Full Description <span class="required">*</span>
						</label>
						<div
							class="editor-wrapper"
							[class.has-error]="isFieldInvalid('description')"
						>
							<div #quillEditor></div>
						</div>
						<p class="form-hint">
							Detailed service description with formatting options
						</p>
						@if (isFieldInvalid('description')) {
							<p class="form-error">
								<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
									<path
										fill-rule="evenodd"
										d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
										clip-rule="evenodd"
									/>
								</svg>
								Full description is required
							</p>
						}
					</div>

					<!-- Pricing & Duration Row -->
					<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
						<!-- Pricing -->
						<div class="form-group">
							<label class="form-label"> Pricing </label>
							<div class="input-with-icon">
								<span class="input-icon font-semibold text-lg">₹</span>
								<input
									type="number"
									formControlName="pricing"
									placeholder="0"
									min="0"
									class="form-input"
									[class.has-error]="isFieldInvalid('pricing')"
								/>
							</div>
							@if (isFieldInvalid('pricing')) {
								<p class="form-error">
									<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
										<path
											fill-rule="evenodd"
											d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
											clip-rule="evenodd"
										/>
									</svg>
									Pricing must be 0 or greater
								</p>
							}
						</div>

						<!-- Duration -->
						<div class="form-group">
							<label class="form-label">
								Duration <span class="required">*</span>
							</label>
							<div class="input-with-icon">
								<svg
									class="input-icon w-5 h-5"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
								<input
									type="number"
									formControlName="duration_minutes"
									placeholder="30"
									min="15"
									class="form-input"
								/>
							</div>
							<p class="form-hint">Duration in minutes (min: 15)</p>
						</div>
					</div>

					<!-- Display Order -->
					<div class="form-group">
						<label class="form-label">Display Order</label>
						<div class="input-with-icon">
							<svg
								class="input-icon w-5 h-5"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
								/>
							</svg>
							<input
								type="number"
								formControlName="display_order"
								placeholder="0"
								min="0"
								class="form-input"
							/>
						</div>
						<p class="form-hint">Lower numbers appear first in listings</p>
					</div>

					<!-- Is Consultation Toggle -->
					<div class="form-group">
						<div
							class="flex items-start gap-4 p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl border border-purple-100"
						>
							<input
								type="checkbox"
								formControlName="is_consultation"
								id="is_consultation"
								class="form-checkbox mt-0.5"
							/>
							<div class="flex-1">
								<label
									for="is_consultation"
									class="font-semibold text-gray-800 cursor-pointer"
								>
									This is a consultation service
								</label>
								<p class="text-sm text-gray-600 mt-1">
									Consultation services don't require prior consultation. Other
									services require customers to have a consultation first.
								</p>
							</div>
						</div>
					</div>

					<!-- Is Featured Toggle -->
					<div class="form-group">
						<div
							class="flex items-start gap-4 p-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-amber-100"
						>
							<input
								type="checkbox"
								formControlName="is_featured"
								id="is_featured"
								class="form-checkbox mt-0.5"
							/>
							<div class="flex-1">
								<label
									for="is_featured"
									class="font-semibold text-gray-800 cursor-pointer"
								>
									Featured Service
								</label>
								<p class="text-sm text-gray-600 mt-1">
									Featured services are displayed on the homepage. If no services
									are marked as featured, the latest 3 will be shown.
								</p>
							</div>
						</div>
					</div>

					<!-- Image Upload -->
					<div class="form-group">
						<label class="form-label">
							Service Image <span class="required">*</span>
						</label>

						@if (!imagePreview()) {
							<div
								class="group border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-[#5d202d] hover:bg-[#5d202d]/5 transition-all duration-300 cursor-pointer"
								(click)="fileInput.click()"
							>
								<input
									type="file"
									accept="image/*"
									(change)="onFileSelected($event)"
									class="hidden"
									#fileInput
								/>
								<div class="inline-flex flex-col items-center gap-4">
									<div
										class="w-20 h-20 bg-gradient-to-br from-[#5d202d]/10 to-[#caa78a]/10 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
									>
										<svg
											class="w-10 h-10 text-[#5d202d]"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="1.5"
												d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
											/>
										</svg>
									</div>
									<div>
										<p class="text-[#5d202d] font-semibold text-lg">
											Click to upload image
										</p>
										<p class="text-sm text-gray-500 mt-1">
											PNG, JPG, GIF up to 5MB
										</p>
									</div>
								</div>
							</div>
						} @else {
							<div
								class="relative rounded-xl overflow-hidden border-2 border-[#5d202d]/30 shadow-lg group"
							>
								<img
									[src]="imagePreview()"
									alt="Preview"
									class="w-full aspect-4/3 object-cover"
									(error)="onImageError($event)"
								/>
								<button
									type="button"
									(click)="removeImage()"
									class="absolute top-2 right-2 p-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors shadow-lg"
								>
									<svg
										class="w-5 h-5"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M6 18L18 6M6 6l12 12"
										/>
									</svg>
								</button>
							</div>
						}
						@if (isFieldInvalid('image') && !imagePreview()) {
							<p class="form-error">
								<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
									<path
										fill-rule="evenodd"
										d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
										clip-rule="evenodd"
									/>
								</svg>
								Service image is required
							</p>
						}
					</div>
				</form>
			</div>

			<!-- Detail Page Content -->
			<div class="bg-white rounded-2xl shadow-lg p-8">
				<h2 class="text-xl font-cenzo font-bold text-primary mb-2 flex items-center gap-2">
					<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
						/>
					</svg>
					Detail Page Content
				</h2>
				<p class="text-sm text-charcoal/60 mb-6">
					This fills the public service page at
					<span class="font-mono text-primary">/services/{{ previewSlug() }}</span>. Every
					section is optional — leave one empty and the page skips it.
				</p>

				<form [formGroup]="serviceForm" class="space-y-3">
					<!-- ── SEO ── -->
					<div class="detail-section">
						<button type="button" class="detail-toggle" (click)="toggleSection('seo')">
							<span>Search Engine Listing</span>
							<span class="detail-count">Meta title &amp; description</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'seo'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'seo') {
							<div class="detail-body">
								<div class="form-group">
									<label class="form-label">Meta Title</label>
									<input
										type="text"
										formControlName="meta_title"
										placeholder="Hair System for Men in Hyderabad | The OG Hair Studio"
										class="form-input"
									/>
									<p class="form-hint">
										Falls back to the service name if left empty.
									</p>
								</div>
								<div class="form-group">
									<label class="form-label">Meta Description</label>
									<textarea
										formControlName="meta_description"
										rows="3"
										placeholder="Best non-surgical hair system for men in Hyderabad..."
										class="form-input"
									></textarea>
									<p class="form-hint">
										Falls back to the short description if left empty.
									</p>
								</div>
							</div>
						}
					</div>

					<!-- ── Intro ── -->
					<div class="detail-section">
						<button type="button" class="detail-toggle" (click)="toggleSection('intro')">
							<span>Intro</span>
							<span class="detail-count">Opening paragraphs</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'intro'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'intro') {
							<div class="detail-body">
								<div class="form-group">
									<textarea
										formControlName="intro"
										rows="8"
										placeholder="A receding hairline or a thinning crown doesn't have to mean surgery...&#10;&#10;Every system starts with a proper consultation, not a product pitch..."
										class="form-input"
									></textarea>
									<p class="form-hint">
										Leave a blank line between paragraphs — each becomes its own
										paragraph on the page.
									</p>
								</div>
							</div>
						}
					</div>

					<!-- ── Why choose us ── -->
					<div class="detail-section">
						<button type="button" class="detail-toggle" (click)="toggleSection('why')">
							<span>Why The OG Hair Studio</span>
							<span class="detail-count">{{ whyUsPoints.length }} points</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'why'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'why') {
							<div class="detail-body">
								<div class="form-group">
									<label class="form-label">Heading</label>
									<input
										type="text"
										formControlName="why_us_title"
										[placeholder]="defaultWhyUsTitle()"
										class="form-input"
									/>
								</div>
								<div formArrayName="why_us_points" class="repeater">
									@for (point of whyUsPoints.controls; track $index) {
										<div class="repeater-row">
											<span class="repeater-index">{{ $index + 1 }}</span>
											<input
												type="text"
												[formControlName]="$index"
												placeholder="Custom hairline and density matching, built to suit your face"
												class="form-input"
											/>
											<div class="repeater-actions">
												<button
													type="button"
													class="repeater-btn"
													title="Move up"
													[disabled]="$index === 0"
													(click)="moveItem(whyUsPoints, $index, -1)"
												>
													&#8593;
												</button>
												<button
													type="button"
													class="repeater-btn"
													title="Move down"
													[disabled]="$index === whyUsPoints.length - 1"
													(click)="moveItem(whyUsPoints, $index, 1)"
												>
													&#8595;
												</button>
												<button
													type="button"
													class="repeater-btn is-danger"
													title="Remove"
													(click)="removeAt(whyUsPoints, $index)"
												>
													&#10005;
												</button>
											</div>
										</div>
									}
								</div>
								<button type="button" class="repeater-add" (click)="addWhyUsPoint()">
									+ Add point
								</button>
							</div>
						}
					</div>

					<!-- ── Common concerns ── -->
					<div class="detail-section">
						<button
							type="button"
							class="detail-toggle"
							(click)="toggleSection('concerns')"
						>
							<span>Common Concerns We Address</span>
							<span class="detail-count">{{ concerns.length }} cards</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'concerns'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'concerns') {
							<div class="detail-body">
								<div class="form-group">
									<label class="form-label">Heading</label>
									<input
										type="text"
										formControlName="concerns_title"
										placeholder="Common Concerns We Address"
										class="form-input"
									/>
								</div>
								<div formArrayName="concerns" class="repeater">
									@for (concern of concerns.controls; track $index) {
										<div class="repeater-card" [formGroupName]="$index">
											<div class="repeater-card-head">
												<span class="repeater-index">{{ $index + 1 }}</span>
												<div class="repeater-actions">
													<button
														type="button"
														class="repeater-btn"
														title="Move up"
														[disabled]="$index === 0"
														(click)="moveItem(concerns, $index, -1)"
													>
														&#8593;
													</button>
													<button
														type="button"
														class="repeater-btn"
														title="Move down"
														[disabled]="$index === concerns.length - 1"
														(click)="moveItem(concerns, $index, 1)"
													>
														&#8595;
													</button>
													<button
														type="button"
														class="repeater-btn is-danger"
														title="Remove"
														(click)="removeAt(concerns, $index)"
													>
														&#10005;
													</button>
												</div>
											</div>
											<input
												type="text"
												formControlName="title"
												placeholder="Thinning Crown"
												class="form-input"
											/>
											<textarea
												formControlName="description"
												rows="2"
												placeholder="Gradual density loss at the back or top of the head"
												class="form-input"
											></textarea>
										</div>
									}
								</div>
								<button type="button" class="repeater-add" (click)="addConcern()">
									+ Add concern
								</button>
							</div>
						}
					</div>

					<!-- ── How it works ── -->
					<div class="detail-section">
						<button type="button" class="detail-toggle" (click)="toggleSection('steps')">
							<span>How It Works</span>
							<span class="detail-count">{{ howItWorks.length }} steps</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'steps'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'steps') {
							<div class="detail-body">
								<div class="form-group">
									<label class="form-label">Heading</label>
									<input
										type="text"
										formControlName="how_it_works_title"
										placeholder="How It Works"
										class="form-input"
									/>
								</div>
								<div formArrayName="how_it_works" class="repeater">
									@for (step of howItWorks.controls; track $index) {
										<div class="repeater-card" [formGroupName]="$index">
											<div class="repeater-card-head">
												<span class="repeater-index">{{ $index + 1 }}</span>
												<div class="repeater-actions">
													<button
														type="button"
														class="repeater-btn"
														title="Move up"
														[disabled]="$index === 0"
														(click)="moveItem(howItWorks, $index, -1)"
													>
														&#8593;
													</button>
													<button
														type="button"
														class="repeater-btn"
														title="Move down"
														[disabled]="
															$index === howItWorks.length - 1
														"
														(click)="moveItem(howItWorks, $index, 1)"
													>
														&#8595;
													</button>
													<button
														type="button"
														class="repeater-btn is-danger"
														title="Remove"
														(click)="removeAt(howItWorks, $index)"
													>
														&#10005;
													</button>
												</div>
											</div>
											<input
												type="text"
												formControlName="title"
												placeholder="Consultation"
												class="form-input"
											/>
											<textarea
												formControlName="description"
												rows="2"
												placeholder="we assess your hair loss pattern, lifestyle, and goals"
												class="form-input"
											></textarea>
										</div>
									}
								</div>
								<button type="button" class="repeater-add" (click)="addStep()">
									+ Add step
								</button>
							</div>
						}
					</div>

					<!-- ── Who it's for ── -->
					<div class="detail-section">
						<button type="button" class="detail-toggle" (click)="toggleSection('who')">
							<span>Who It's For</span>
							<span class="detail-count">Single paragraph</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'who'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'who') {
							<div class="detail-body">
								<div class="form-group">
									<textarea
										formControlName="who_its_for"
										rows="4"
										placeholder="Ideal for men noticing thinning or a receding hairline who want a natural, low-maintenance solution without surgery..."
										class="form-input"
									></textarea>
								</div>
							</div>
						}
					</div>

					<!-- ── FAQs ── -->
					<div class="detail-section">
						<button type="button" class="detail-toggle" (click)="toggleSection('faqs')">
							<span>FAQs</span>
							<span class="detail-count">{{ faqs.length }} questions</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'faqs'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'faqs') {
							<div class="detail-body">
								<div formArrayName="faqs" class="repeater">
									@for (faq of faqs.controls; track $index) {
										<div class="repeater-card" [formGroupName]="$index">
											<div class="repeater-card-head">
												<span class="repeater-index">{{ $index + 1 }}</span>
												<div class="repeater-actions">
													<button
														type="button"
														class="repeater-btn"
														title="Move up"
														[disabled]="$index === 0"
														(click)="moveItem(faqs, $index, -1)"
													>
														&#8593;
													</button>
													<button
														type="button"
														class="repeater-btn"
														title="Move down"
														[disabled]="$index === faqs.length - 1"
														(click)="moveItem(faqs, $index, 1)"
													>
														&#8595;
													</button>
													<button
														type="button"
														class="repeater-btn is-danger"
														title="Remove"
														(click)="removeAt(faqs, $index)"
													>
														&#10005;
													</button>
												</div>
											</div>
											<input
												type="text"
												formControlName="question"
												placeholder="Will people be able to tell I'm wearing a hair system?"
												class="form-input"
											/>
											<textarea
												formControlName="answer"
												rows="3"
												placeholder="Not if it's built correctly. Our systems are custom-matched for colour, density, and hairline placement..."
												class="form-input"
											></textarea>
										</div>
									}
								</div>
								<button type="button" class="repeater-add" (click)="addFaq()">
									+ Add FAQ
								</button>
							</div>
						}
					</div>

					<!-- ── Related services ── -->
					<div class="detail-section">
						<button
							type="button"
							class="detail-toggle"
							(click)="toggleSection('related')"
						>
							<span>Related Services</span>
							<span class="detail-count"
								>{{ relatedServiceIds.length }} selected</span
							>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'related'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'related') {
							<div class="detail-body">
								@if (relatedServiceOptions().length === 0) {
									<p class="text-sm text-charcoal/50">
										No other services to link to yet.
									</p>
								} @else {
									<div class="related-grid">
										@for (option of relatedServiceOptions(); track option.id) {
											<label
												class="related-option"
												[class.is-selected]="isRelated(option.id)"
											>
												<input
													type="checkbox"
													class="form-checkbox"
													[checked]="isRelated(option.id)"
													(change)="toggleRelated(option.id)"
												/>
												<span>{{ option.service_name }}</span>
											</label>
										}
									</div>
								}
							</div>
						}
					</div>

					<!-- ── Call to action ── -->
					<div class="detail-section">
						<button type="button" class="detail-toggle" (click)="toggleSection('cta')">
							<span>Call to Action</span>
							<span class="detail-count">Closing block</span>
							<svg
								class="detail-chevron"
								[class.is-open]="openSection() === 'cta'"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M19 9l-7 7-7-7"
								/>
							</svg>
						</button>
						@if (openSection() === 'cta') {
							<div class="detail-body">
								<div class="form-group">
									<label class="form-label">Closing text</label>
									<textarea
										formControlName="cta_text"
										rows="3"
										placeholder="Ready to see what a properly designed hair system for men looks like on you? Book your consultation at our Banjara Hills studio today."
										class="form-input"
									></textarea>
								</div>
								<div class="form-group">
									<label class="form-label">Button label</label>
									<input
										type="text"
										formControlName="cta_button_label"
										placeholder="Book Your Consultation"
										class="form-input"
									/>
									<p class="form-hint">
										Defaults to "Book Your Consultation" if left empty.
									</p>
								</div>
							</div>
						}
					</div>
				</form>
			</div>
		</div>

		<!-- Right Side: Live Preview -->
		<div class="lg:sticky lg:top-24 h-fit">
			<div class="bg-white rounded-2xl shadow-lg p-8">
				<h2 class="text-xl font-cenzo font-bold text-primary mb-6 flex items-center gap-2">
					<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
						/>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
						/>
					</svg>
					Live Preview
				</h2>

				<!-- Service Card Preview -->
				<div class="bg-gradient-to-br from-charcoal/5 to-primary/5 rounded-xl p-6">
					<div class="bg-white rounded-2xl shadow-xl overflow-hidden">
						<!-- Service Image Preview -->
						<div
							class="relative h-56 overflow-hidden bg-gradient-to-br from-primary/10 to-secondary/10"
						>
							@if (previewData().image_path) {
								<img
									[src]="previewData().image_path"
									alt="Service preview"
									class="w-full h-full object-cover"
									(error)="onImageError($event)"
								/>
							} @else {
								<div class="w-full h-full flex items-center justify-center">
									<svg
										class="w-20 h-20 text-charcoal/20"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
										/>
									</svg>
								</div>
							}
							<div
								class="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-semibold bg-green-500/90 text-white backdrop-blur-sm"
							>
								Active
							</div>
						</div>

						<!-- Service Details Preview -->
						<div class="p-6">
							<h3 class="font-cenzo text-xl font-bold text-primary mb-2 line-clamp-1">
								{{ previewData().service_name }}
							</h3>
							<p class="text-charcoal/60 text-sm mb-4 line-clamp-2">
								{{ previewData().short_description }}
							</p>

							<!-- Pricing Preview -->
							<div class="flex items-center gap-2 mb-4">
								<svg
									class="w-5 h-5 text-secondary"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
								<span class="text-lg font-bold text-primary"
									>₹{{ previewData().pricing }}</span
								>
							</div>

							<!-- Full Description Preview -->
							<div class="pt-4 border-t border-charcoal/10">
								<div
									class="text-sm text-charcoal/70 prose prose-sm max-w-none"
									[innerHTML]="
										previewData().description ||
										'Detailed description will appear here'
									"
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Image Cropper Modal -->
<app-image-cropper-modal
	#imageCropper
	[imageFile]="selectedImageForCrop"
	[aspectRatio]="4 / 3"
	[resizeToWidth]="800"
	[resizeToHeight]="600"
	(cropped)="onImageCropped($event)"
	(cancelled)="onImageCropCancelled()"
></app-image-cropper-modal>
